<div class="relative" (keydown.escape)="resultsOpen.set(false)">
  <div class="space-y-2">
    <label [attr.for]="searchInputId" class="block text-sm font-medium text-slate-700">
      Search property
    </label>

    <div class="relative">
      <svg
        class="pointer-events-none absolute left-4 top-1/2 size-4 -translate-y-1/2 text-slate-400"
        viewBox="0 0 16 16" fill="none" aria-hidden="true"
      >
        <circle cx="7" cy="7" r="4.5" stroke="currentColor" stroke-width="1.5" />
        <path d="m10.5 10.5 3 3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
      </svg>

      <input
        [id]="searchInputId"
        type="text"
        autocomplete="off"
        [formControl]="term"
        placeholder="Search property..."
        class="h-11 w-full rounded-lg border border-slate-200 bg-white pl-11 pr-24
               text-[15px] text-slate-900 placeholder:text-slate-400
               focus:border-indigo-500 focus:outline-none focus:ring-2
               focus:ring-indigo-500/30"
      />

      <div class="absolute right-3 top-1/2 flex -translate-y-1/2 items-center gap-2">
        @if (loading()) {
          <svg class="size-4 animate-spin text-indigo-600" viewBox="0 0 16 16" fill="none" aria-label="Searching">
            <circle cx="8" cy="8" r="6.25" stroke="currentColor" stroke-width="1.6" opacity="0.3" />
            <path d="M14.25 8A6.25 6.25 0 0 0 8 1.75" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" />
          </svg>
        }
        @if (term.value) {
          <button
            type="button"
            (click)="clear()"
            class="rounded px-1.5 py-0.5 text-xs font-medium text-slate-500 hover:bg-slate-100
                   hover:text-slate-700 focus:outline-none focus-visible:ring-2
                   focus-visible:ring-indigo-500"
          >
            Clear
          </button>
        }
      </div>
    </div>
  </div>

  @if (resultsOpen()) {
  <div class="absolute inset-x-0 top-full z-40 mt-2 max-h-80 overflow-y-auto rounded-xl border border-slate-200 bg-white p-2 shadow-xl">
  @if (error()) {
    <p role="alert" class="rounded-lg border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700">
      {{ error() }}
    </p>
  } @else if (visibleResults().length) {
    <div class="p-1">
      <ul class="grid gap-2">
        @for (item of visibleResults(); track item.id) {
          <li>
            <button
              type="button"
              (click)="selectProperty(item)"
              class="w-full rounded-lg border px-4 py-3 text-left transition-colors
                     focus:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500
                     focus-visible:ring-offset-2"
              [class]="
                selectedId() === item.id
                  ? 'border-indigo-400 bg-indigo-50/70 ring-1 ring-indigo-400'
                  : 'border-slate-200 bg-white hover:border-slate-300 hover:bg-slate-50'
              "
            >
              <span class="block truncate text-[15px] font-semibold text-slate-900">
                {{ item.propertyName }}
              </span>
              <span class="mt-0.5 block truncate text-sm text-slate-500">
                {{ subtitle(item) }}
              </span>
              @if (item.configurations.length || priceRange(item)) {
                <span class="mt-1 flex items-center justify-between gap-3 text-xs text-slate-500">
                  <span class="truncate">{{ item.configurations.join(', ') }}</span>
                  <span class="shrink-0 font-semibold tabular-nums text-slate-700">{{ priceRange(item) }}</span>
                </span>
              }
            </button>
          </li>
        }
      </ul>
    </div>
  } @else if (loading()) {
    <p class="p-3 text-sm text-slate-500" role="status">Searching…</p>
  } @else if (searched()) {
    <p class="rounded-lg border border-slate-200 bg-slate-50 px-4 py-3 text-sm text-slate-500">
      No matching property found.
    </p>
  }
  </div>
  }
</div>
